/* eslint-disable no-restricted-syntax -- this line was auto generated, hence fix the issue timely */
import React, { useMemo } from "react";
import { Sidebar } from "../../Container";
import SearchTabs from "../../SearchTabs";
import { SkeletonFlightCard } from "../SkeletonFlightCard";
import { SkeletonListKeyValue } from "../SkeletonListKeyValue";
import { SearchLoadingMessage } from "components/elements/SearchLoadingMessage";
import Frame from "components/elements/Frame";
import flights_web_reduce_spacing_sr_ddot from "utils/experiments/funnel/flights_web_reduce_spacing_sr_ddot";
import useRouteName from "hooks/useRouteName";
import { trackWithDefaultStage } from "@flights/et-universal";
import styles from "./SkeletonSearchDesktop.module.css";

interface Props {
  text?: string;
}

export const SkeletonSearchContent = ({ count = 4 }: { count?: number }) => {
  return (
    <React.Fragment>
      <SearchLoadingMessage />
      {Array.from({ length: count }).map((_, i) =>
        flights_web_reduce_spacing_sr_ddot.trackWithDefaultStage() ? (
          <Frame key={i} mt={i === 0 ? 4 : 0} mb={2}>
            <SkeletonFlightCard />
          </Frame>
        ) : (
          <Frame key={i} mt={3} mb={3}>
            <SkeletonFlightCard />
          </Frame>
        )
      )}
    </React.Fragment>
  );
};

const SkeletonSearchDesktop: React.FunctionComponent<Props> = () => {
  const routeName = useRouteName();
  const className = useMemo(
    () =>
      routeName.includes("flightdetails") && !!trackWithDefaultStage("flights_web_tech_pause_sr_loading", 1)
        ? styles.blur
        : "",
    [routeName]
  );

  return (
    <Frame direction="row" className={className}>
      {/* START: Left Column */}
      <Sidebar pt={flights_web_reduce_spacing_sr_ddot.trackWithDefaultStage() ? 0 : 4}>
        <Frame p={4}>
          <SkeletonListKeyValue amount={12} />
        </Frame>
      </Sidebar>
      {/* END: Left Column */}

      {/* START: Right Column */}
      <Frame grow={1} pt={flights_web_reduce_spacing_sr_ddot.trackWithDefaultStage() ? 0 : 4} pb={0} pl={6}>
        <SearchTabs showBestRankingInfo fill />
        <SkeletonSearchContent />
      </Frame>
      {/* END: Right Column */}
    </Frame>
  );
};

export default SkeletonSearchDesktop;
